module.exports = __webpack_public_path__ + "static/media/one_person_tap.39ecebe1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/taptile/src/one_person_tap.gif
// module id = 435
// module chunks = 0